/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  ProgramTypeName,
  ProgramTypeNameOptional,
  ProgramTypeNameMetaI,
  ProgramTypeNameTrackedI,
} from "./program-type-name";
import {
  ProgramTypeNameTracked,
  ProgramTypeNameMeta,
} from "./program-type-name";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ProgramTypeRef,
  ProgramTypeRefOptional,
  ProgramTypeRefMetaI,
  ProgramTypeRefTrackedI,
} from "./program-type-ref";
import { ProgramTypeRefTracked, ProgramTypeRefMeta } from "./program-type-ref";

/**
 *
 * @export
 * @interface ProgramTypeRefAndName
 */
export interface ProgramTypeRefAndNameOptional extends ProgramTypeNameOptional {
  /**
   *
   * @type {number}
   * @memberof ProgramTypeRefAndName
   */
  assignId?: number;
  /**
   *
   * @type {string}
   * @memberof ProgramTypeRefAndName
   */
  programName?: string;
}

export interface ProgramTypeRefAndName
  extends ProgramTypeRefAndNameOptional, ProgramTypeName, ProgramTypeRef {
  /**
   *
   * @type {number}
   * @memberof ProgramTypeRefAndName
   */
  assignId: number;
  /**
   *
   * @type {string}
   * @memberof ProgramTypeRefAndName
   */
  programName?: string;
}

export interface ProgramTypeRefAndNameTrackedI extends ProgramTypeNameOptional {
  /**
   *
   * @type {number}
   * @memberof ProgramTypeRefAndName
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ProgramTypeRefAndName
   */
  programName?: string;
  programNameIsSet: boolean;
}

transformDatesMap.set(
  "ProgramTypeRefAndName",
  function (model: ProgramTypeRefAndName) {},
);

export type ProgramTypeRefAndNameMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  programName: PropertyMeta<MetaTypeBase<string>>;
}>;

export var ProgramTypeRefAndNameMeta: ProgramTypeRefAndNameMetaI =
  {} as ProgramTypeRefAndNameMetaI;
ProgramTypeRefAndNameMeta = typeMeta("ProgramTypeRefAndName", {
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  programName: propertyMeta(
    "programName",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
});

const metaI = ProgramTypeRefAndNameMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([ProgramTypeRefMeta]);
  metaI.assignId.inheritedFrom = ProgramTypeRefMeta.assignId;
  metaI.interfaces = metaI.interfaces.concat([ProgramTypeNameMeta]);
  metaI.programName.inheritedFrom = ProgramTypeNameMeta.programName;
});

export class ProgramTypeRefAndNameTracked
  extends ProgramTypeNameTracked
  implements ProgramTypeRefAndNameTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  programName__I?: string = undefined;
  programNameIsSet: boolean = false;
  set programName(v: undefined | string) {
    if (v !== undefined) {
      this.programName__I = v;
      this.programNameIsSet = true;
    } else {
      this.programName__I = v || undefined;
      this.programNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get programName() {
    return this.programName__I;
  }
  constructor(config?: ProgramTypeRefAndNameOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }
  }
  assignFrom(
    config: ProgramTypeRefAndNameOptional,
    options?: AssignOptions,
  ): ProgramTypeRefAndNameTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (
      config.programName &&
      this.programNameApplyFilter(optionsRequired.filter)
    ) {
      this.programName = config.programName;
      if (optionsRequired.unassign) this.programNameIsSet = false;
      else this.programNameIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): ProgramTypeRefAndNameTrackedI {
    const cloned = {} as ProgramTypeRefAndNameTrackedI;
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.programNameIsSetDeep() &&
      this.programNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.programNameIsSet = true;
      cloned.programName = this.programName;
    } else {
      //cloned.programNameIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): ProgramTypeRefAndNameTrackedI {
    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.programNameApplyFilter(filter)) this.programNameIsSet = false;

    return this;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ProgramTypeRefAndNameMeta.assignId,
      ProgramTypeRefAndNameMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  programNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ProgramTypeRefAndNameMeta.programName,
      ProgramTypeRefAndNameMeta,
      this.programName,
      this,
    );
  }
  programNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.programNameIsSet && this.programNameApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.programNameIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
